import { Action } from 'redux';

import { NewWorkbookForDatasource } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface NewWorkbookForDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function newWorkbookForDatasource(contentInfo: IContentInfo): NewWorkbookForDatasourceAction {
  return {
    type: NewWorkbookForDatasource,
    contentInfo
  };
}

export const isNewWorkbookForDatasourceAction = isActionFactory<NewWorkbookForDatasourceAction>(NewWorkbookForDatasource);
